// @flow
import React from "react"
import Button from "./Button"
import FeatureGalleryItem from "./FeatureGalleryItem"
import { rhythm } from "../utils/typography"
import { primaryDark } from "../utils/colors"
import benefitsIcon from "../images/features/feature-benefits-icon.svg"
import complianceIcon from "../images/features/feature-compliance-icon.svg"
import hrisIcon from "../images/features/feature-hris-icon.svg"
import marketplaceIcon from "../images/features/feature-marketplace-icon.svg"
import onboardingIcon from "../images/features/feature-onboarding-icon.svg"
import payrollIcon from "../images/features/feature-payroll-icon.svg"

const features = [
  {
    target: "/features/#benefits",
    icon: benefitsIcon,
    title: "Benefits",
    description:
      "Simple employee benefits quoting, enrollment, and management in one place.",
  },
  {
    target: "/features/#onboarding",
    icon: onboardingIcon,
    title: "Onboarding",
    description:
      "Streamlined employee setup and document collection for growing companies.",
  },
  {
    target: "/features/#marketplace",
    icon: marketplaceIcon,
    title: "Marketplace",
    description:
      "World class partners and exclusive integrations to tailor your offering to changing needs.",
  },
  {
    target: "/features/#compliance",
    icon: complianceIcon,
    title: "Compliance",
    description:
      "Effortless Affordable Care Act compliance management, reporting, and e-filing.",
  },
  {
    target: "/features/#hris",
    icon: hrisIcon,
    title: "HRIS",
    description:
      "Powerful PTO tracking, performance reviews, and goal setting for managers.",
  },
  {
    target: "/features/#payroll",
    icon: payrollIcon,
    title: "Payroll",
    description:
      "Robust payroll integrations with ADP Workforce Now, Paylocity, and TRAXPayroll to cut administrative work.",
  },
]

const FeatureGallery = () => (
  <div css={styles.wrapper}>
    <h3 css={styles.headline}>Product Features</h3>
    <div css={styles.gallery}>
      {features.map(feature => (
        <FeatureGalleryItem key={feature.target} {...feature} />
      ))}
    </div>
    <div css={styles.cta}>
      <Button to="/features/">See All Features</Button>
    </div>
  </div>
)

const styles = {
  wrapper: {
    padding: `${rhythm(3)} 0`,
  },
  headline: {
    textAlign: "center",
    color: primaryDark,
  },
  gallery: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    position: "relative",
    margin: `0 -${rhythm()} ${rhythm()} -${rhythm()}`,
  },
  cta: {
    textAlign: "center",
  },
}

export default FeatureGallery



// WEBPACK FOOTER //
// ./src/components/FeatureGallery.js